import { useMemo, useState } from 'react';
import { newsList } from '@/mocks/news';
import NewsCard from '@/components/feature/NewsCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import Pagination from '@/components/base/Pagination';
import EmptyState from '@/components/base/EmptyState';
import usePageMeta from '@/hooks/usePageMeta';

const PAGE_SIZE = 5;

const categories = ['全部', '剧集动态', '主创访谈', '幕后揭秘', '行业观察', '观众热议', '影视资讯'];

export default function News() {
  usePageMeta({
    title: '影视资讯 - 女友的妈妈',
    description:
      '《女友的妈妈》最新影视资讯汇总，涵盖剧集动态、主创访谈、幕后揭秘与行业观察，按时间顺序呈现相关报道。',
    keywords: '女友的妈妈影视资讯,女友的妈妈最新动态,影视新闻',
  });

  const [category, setCategory] = useState('全部');
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const list = category === '全部' ? newsList : newsList.filter((item) => item.category === category);
    return [...list].sort((a, b) => b.date.localeCompare(a.date));
  }, [category]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const current = Math.min(page, totalPages);
  const pageItems = filtered.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);

  const handleCategory = (value: string) => {
    setCategory(value);
    setPage(1);
  };

  return (
    <>
      <section className="w-full bg-background-100 border-b border-background-200">
        <div className="max-w-[1080px] mx-auto px-4 md:px-8 py-8 md:py-10">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '影视资讯' }]} />
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-4">
            影视资讯
          </h1>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl">
            追踪《女友的妈妈》的最新动态与行业观察，按发布时间的先后顺序浏览全部资讯。
          </p>
        </div>
      </section>

      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="max-w-[1080px] mx-auto">
          <div className="flex flex-wrap items-center gap-2 mb-6">
            {categories.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => handleCategory(item)}
                className={`px-4 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  category === item
                    ? 'bg-secondary-500 text-background-50'
                    : 'border border-background-300 text-foreground-600 hover:border-secondary-400 hover:text-secondary-700'
                }`}
              >
                {item}
              </button>
            ))}
          </div>

          {pageItems.length === 0 ? (
            <EmptyState
              icon="ri-newspaper-line"
              title="暂无资讯更新"
              description="当前分类下暂时没有内容，换一个分类看看吧。"
              actionLabel="查看全部资讯"
              onAction={() => handleCategory('全部')}
            />
          ) : (
            <>
              <div className="space-y-3 md:space-y-4">
                {pageItems.map((item) => (
                  <NewsCard key={item.id} news={item} />
                ))}
              </div>
              <Pagination current={current} total={totalPages} onChange={setPage} />
            </>
          )}
        </div>
      </div>
    </>
  );
}